/* eslint-disable react/display-name */
import React from 'react'

import { Formik, Form, useField, Field } from 'formik'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { submitEventForm } from '../../_actions'
import { useWindowSize, validateEventForm } from '../../_helpers'
import {
    Container,
    devices,
    colors,
    Button,
    UpperHeader,
    Input,
    FormError,
    MultiChoiceInput,
    RadioInput,
    BaseLabel,
    Header,
    Textarea,
} from '../Common'

const TextInput = (props) => {
    const [field, meta] = useField(props)
    return (
        <InputWrap>
            {meta.touched && meta.error ? <FormError>{meta.error}</FormError> : null}
            <Input {...field} {...props} aria-label={props.placeholder} />
        </InputWrap>
    )
}

const TextArea = (props) => {
    const [field, meta] = useField(props)
    return (
        <InputWrap>
            {meta.touched && meta.error ? <FormError>{meta.error}</FormError> : null}
            <Textarea {...field} {...props} aria-label={props.placeholder} />
        </InputWrap>
    )
}

const RadioButton = (props) => {
    const [field, meta] = useField({ ...props, name: 'event_type', type: 'radio' })
    return (
        <BaseLabel>
            {props.value}
            <input type="radio" {...field} {...props} />
            <RadioInput />
        </BaseLabel>
    )
}

const Choice = (props) => {
    const [field, meta] = useField({ ...props, name: 'interest', type: 'checkbox' })
    return (
        <BaseLabel>
            {props.value}
            <input type="checkbox" {...field} {...props} />
            <MultiChoiceInput />
        </BaseLabel>
    )
}

export default function EventForm() {
    const { eventMessage, eventError } = useSelector((state) => state.content, shallowEqual)
    const dispatch = useDispatch()

    const { width } = useWindowSize()
    const mobile = width < 480

    const initialFormValues = {
        email: '',
        full_name: '',
        company: '',
        phone_number: '',
        event_date: '',
        event_location: '',
        event_time: '',
        event_theme: '',
        number_of_guests: '',
        budget: '',
        event_type: '',
        other_event: '',
        interest: [],
        table_count: '',
        items: '',
        other_information: '',
    }

    return (
        <FormContainer>
            {eventMessage || eventError ? (
                <InputWrap style={{ marginTop: '20px' }}>{eventMessage || eventError}</InputWrap>
            ) : (
                <>
                    <UpperHeader fontSize={mobile ? 26 : 42} marginbottom={60}>
                        Event Form
                    </UpperHeader>
                    <Formik initialValues={initialFormValues} validate={validateEventForm} onSubmit={(values) => dispatch(submitEventForm(values))}>
                        <FormWrap>
                            <TextInput type="email" name="email" placeholder="Email" />
                            <TextInput type="text" name="full_name" placeholder="Full Name" />
                            <TextInput type="text" name="company" placeholder="Company" />
                            <TextInput type="tel" name="phone_number" placeholder="Phone Number" />
                            <TextInput type="date" name="event_date" placeholder="Event Date" />
                            <TextInput type="text" name="event_location" placeholder="Event Location" />
                            <TextInput type="text" name="event_time" placeholder="Event Time(s)" />
                            <TextInput type="text" name="event_theme" placeholder="Event Theme" />
                            <TextInput type="number" name="number_of_guests" placeholder="Number of Guests" />
                            <TextInput name="budget" placeholder="Budget" />
                            <TextInput type="number" name="table_count" placeholder="Table Count" />
                            <TextArea name="items" placeholder="Items on our website that you liked" />
                            <TextArea name="other_information" placeholder="Other important information about your event" />
                            <InputWrap role="group">
                                <Header fontSize={27} marginbottom={mobile ? 60 : 20} margintop={mobile ? 100 : 20}>
                                    Type of Event
                                </Header>
                                <RadioButton value="Corporate" />
                                <RadioButton value="Gala" />
                                <RadioButton value="Bar Mitzvah" />
                                <RadioButton value="Personal Event" />
                                <RadioButton value="School Related" />
                                <BaseLabel>
                                    Other: &nbsp;
                                    <input type="radio" name="event_type" value="Other (see below)" />
                                    <RadioInput />
                                    <Field type="text" placeholder="Specify" name="other_event" aria-label="specify" as={OtherInput} />
                                </BaseLabel>
                            </InputWrap>
                            <InputWrap role="group">
                                <Header fontSize={27}>Interest</Header>
                                <UpperHeader fontSize={8} margintop={10} marginbottom={mobile ? 60 : 20}>
                                    Check all that apply
                                </UpperHeader>
                                <Choice id="decor" value="Decor" />
                                <Choice id="linens" value="Linens" />
                                <Choice id="centerpieces" value="Centerpieces / Florals" />
                                <Choice id="seating" value="Seating" />
                                <Choice id="furniture" value="Lounge Furniture" />
                                <Choice id="bars" value="Bars" />
                                <Choice id="lighting" value="Lighting" />
                                <Choice id="signage" value="Signage / Graphics" />
                            </InputWrap>
                            <Button type="submit">SUBMIT</Button>
                        </FormWrap>
                    </Formik>
                </>
            )}
        </FormContainer>
    )
}

const FormContainer = styled(Container)`
    padding-bottom: 85px;
    min-height: 100vh;
`

const FormWrap = styled(Form)`
    display: flex;
    flex-direction: column;
`

const InputWrap = styled.div`
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: ${colors.white};
    width: 45%;

    @media ${devices.small} {
        width: 100%;
    }
`

const OtherInput = styled(Input)`
    padding: 2px;
    font-size: 16px;
    margin-bottom: 0;
`
